import { gql } from "@apollo/client";

export const SAVE_VALORACION_CP = gql`
mutation SaveValoracionCP($input: AddVisitaPresencialCPValoracionInput!) {
    saveVisitaPresencialCPValoracion(input: $input) {
        idPresencialCPCD
    }
}`;

export default SAVE_VALORACION_CP;

export const adaptAddPresencialValoracionCPInput = (data) => ({
  idPresencialCPCD: data.idPresencialCPCD ?? 0,
  eCOG: data.eCOG,
  karnofsky: data.karnofsky,
  escaras: !!data.escaras,
  estadio: data.estadio,
  diuresis: !!data.diuresis,
  cantidad: data.cantidadDiuresis,
  catarsis: !!data.catarsis,
  caracteristicas: data.caracteristicas,
  idESAS: data.idESAS,
  nauseas: data.nauseas,
  dolor: data.dolor,
  disnea: data.disnea,
  ansiedad: data.ansiedad,
  depresion: data.depresion,
  anorexia: data.anorexia,
  bienestar: data.bienestar,
  cansancio: data.cansancio,
  insomnio: data.insomnio,
  somnolencia: data.somnolencia,
  constipacion: data.constipacion,
  resultadoESAS: data.resultadoESAS,
  idVisita: data.idVisita
});